import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { MessagesSquareIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
import { ConversationList } from '../components/chat/ConversationList';
import { ChatView } from '../components/chat/ChatView';
import { EmptyState } from '../components/ui/EmptyState';
import type { Role } from '../types/marketplace';
export function Messages({
  role
}: {
  role: Role;
}) {
  const {
    matchId
  } = useParams();
  const navigate = useNavigate();
  const basePath = role === 'performer' ? '/p/messages' : '/o/messages';
  return <div className="flex h-[calc(100dvh-76px)] lg:h-[100dvh]" data-id="element-886" data-mp="3f4bwqe93azai">
      <section aria-label="Conversations" className={twMerge('w-full shrink-0 overflow-y-auto border-line lg:block lg:w-[380px] lg:border-r', matchId ? 'hidden' : 'block')} data-id="element-887" data-mp="3f5myy9mvzyzi">
        <h1 className="px-5 pb-3 pt-6 text-[28px] font-bold tracking-[-0.015em] lg:pt-8" data-id="element-888" data-mp="2ml4vnno075y1">Messages</h1>
        <ConversationList role={role} activeId={matchId} basePath={basePath} data-id="element-889" data-mp="2ik34lu48q075" />
      </section>
      <section aria-label="Chat" className={twMerge('min-w-0 flex-1', matchId ? 'block' : 'hidden lg:block')} data-id="element-890" data-mp="xn47ca76cksv">
        {matchId ? <ChatView key={matchId} matchId={matchId} role={role} onBack={() => navigate(basePath)} data-id="element-891" data-mp="17egrsgqn88ov" /> : <div className="grid h-full place-items-center" data-id="element-892" data-mp="1cd1r8dy2moc9">
            <EmptyState icon={<MessagesSquareIcon className="h-7 w-7" data-id="element-894" data-mp="er4fcze75h9a" />} title="Pick a conversation" body="Chats open as soon as you match. Agree the details, then lock it in with a booking offer." data-id="element-893" data-mp="eqcill8v5dhf" />
          </div>}
      </section>
    </div>;
}